import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { LicenseActions } from "@youm-front/license/data-access";
import {
  LicenseLimitExceededVO,
  LicenseLimitExceededReasons
} from "@youm-front/license/domain";
import { Observable } from "rxjs";
import { exhaustMap, takeUntil, tap } from "rxjs/operators";
import { LicenseLimitExceeded } from "youm-lib";
import { RoomActions } from "../actions";
import { RoomService } from "../services";

@Injectable()
export class RoomLicenseEffects implements OnRunEffects {
  constructor(
    private readonly _actions$: Actions,
    private readonly _store: Store,
    private readonly _roomService: RoomService
  ) {}

  // Listen to the license events.
  // Can't move this logic into the license module,
  // because a socket is available within the youm-studio only.
  listenLicenseLimitExceeded$ = createEffect(
    () =>
      this._roomService
        .listenLicenseLimitExceeded()
        .pipe(tap((_) => this.onLicenseLimitExceeded(_))),
    { dispatch: false }
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this._actions$.pipe(
      ofType(RoomActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(this._actions$.pipe(ofType(RoomActions.destroy)))
        )
      )
    );
  }

  private onLicenseLimitExceeded(_: LicenseLimitExceeded) {
    if (_.reason === LicenseLimitExceededReasons.MaxLiveDurationMs) {
      return this._store.dispatch(
        LicenseActions.licenseLimitMaxLiveDuration({
          licenseLimitExceededVO: new LicenseLimitExceededVO({
            roomId: _.roomId,
            reason: _.reason
          })
        })
      );
    }
  }
}
